
import { TestData } from './types';
import type { RuleDocVersion } from '@/lib/posture-analysis/rule-params';
import {
  type LayoutOrderOptions,
  type SopAssessmentMode,
  ACTIVE_COURSE_TEST_DATA,
  PASSIVE_COURSE_TEST_DATA,
  FOOT_BATTERY_TEST_DATA,
  getCourseLayoutOrder,
  getCourseTestDataMap,
  getVisibleCourseTestKeys,
} from './course-playlist-config';

export type { LayoutOrderOptions, SopAssessmentMode };

/** @deprecated Use getCourseTestDataMap — kept for imports/tests. */
export const PASSIVE_TEST_DATA: TestData = PASSIVE_COURSE_TEST_DATA;

/** @deprecated Use getCourseTestDataMap — kept for imports/tests. */
export const ACTIVE_TEST_DATA: TestData = ACTIVE_COURSE_TEST_DATA;

export {
  FOOT_BATTERY_TEST_DATA,
  getVisibleCourseTestKeys,
  getSopPdfExportRows,
  resolveAssessmentTestMode,
  PASSIVE_COURSE_LAYOUT_ORDER as LAYOUT_ORDER,
  PASSIVE_COURSE_LAYOUT_LEGACY as LAYOUT_ORDER_LEGACY,
} from './course-playlist-config';

export const getPassiveTestData = (
  version: RuleDocVersion,
  footBatteryEnabled = false
): TestData =>
  getCourseTestDataMap(version, { mode: 'passive', footBatteryEnabled });

export const getActiveTestData = (version: RuleDocVersion): TestData =>
  getCourseTestDataMap(version, { mode: 'active' });

export const getLayoutOrder = (
  version: RuleDocVersion,
  mode: SopAssessmentMode = 'passive',
  footBatteryEnabled = false
): (string | string[])[] =>
  getCourseLayoutOrder(version, { mode, footBatteryEnabled });
